import { CtaTypes } from '../../types/Cta';
import { TypographyTypes } from '../../types/Typography';

export interface RawStickyCtaProps {
  id: number;
  type: string;
  colorScheme: string;
  title: TypographyTypes;
  cta: CtaTypes;
  scrollThreshold: number;
}

export interface NormalizedStickyCtaProps extends Omit<RawStickyCtaProps, 'id'> { }


const StickyCta = ({
  type,
  colorScheme,
  title,
  cta,
  scrollThreshold,
}: RawStickyCtaProps): NormalizedStickyCtaProps => {
  const normalizedData: NormalizedStickyCtaProps = {
    type,
    colorScheme,
    title,
    cta,
    scrollThreshold,
  }

  return normalizedData
}

export default StickyCta
